export const LOYALTY_CONSTANTS = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  LIMIT_OPTIONS: [10, 20, 30, 50],
} as const;

export const SORT_COLUMNS = {
  NAME: 'name',
  PHONE: 'phone',
  POINTS: 'points',
  TOTAL_SPENT: 'totalSpent',
} as const;

export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

export const PHONE_MASK_LENGTH = 4;
